import { observer } from 'mobx-react';
import { useCallback } from 'react';
import { columnsWidth } from '../constants';
import { OrdersHistoryRow } from './OrderHistoryRow';
import { ordersHistoryStore } from 'src/mobx/ordersHistoryStore/ordersHistoryStore';
import { OrdersHistoryTableColumns } from 'src/mobx/ordersHistoryStore/types';
import ScrollableBlock from 'src/view/containers/ScrollableBlock/ScrollableBlock';
import ColumnTitle from '~/view/components/ColumnTitle/ColumnTitle';
import Pagination from '~/view/components/Controls/Pagination/Pagination';

const OrdersHistoryTable = () => {
  const handleClickPagination = useCallback((pageNumber: number) => {
    ordersHistoryStore.changePage(pageNumber);
  }, []);

  return (
    <>
      <div className="d-flex flex-row mb-4 pr-5">
        <ColumnTitle<OrdersHistoryTableColumns>
          title="txt_order_id"
          columnName={OrdersHistoryTableColumns.OrderID}
          currentField={ordersHistoryStore.sorting.column}
          currentDir={ordersHistoryStore.sorting.direction}
          setFilters={ordersHistoryStore.changeSorting}
          className={`w-${columnsWidth[OrdersHistoryTableColumns.OrderID]}`}
        />
        <ColumnTitle<OrdersHistoryTableColumns>
          title="branch"
          columnName={OrdersHistoryTableColumns.BranchName}
          currentField={ordersHistoryStore.sorting.column}
          currentDir={ordersHistoryStore.sorting.direction}
          setFilters={ordersHistoryStore.changeSorting}
          className={`w-${columnsWidth[OrdersHistoryTableColumns.BranchName]}`}
        />
        <ColumnTitle<OrdersHistoryTableColumns> title="phone" className={`w-${columnsWidth[OrdersHistoryTableColumns.CustomerPhone]}`} />
        <ColumnTitle<OrdersHistoryTableColumns>
          title="status"
          columnName={OrdersHistoryTableColumns.Status}
          currentField={ordersHistoryStore.sorting.column}
          currentDir={ordersHistoryStore.sorting.direction}
          setFilters={ordersHistoryStore.changeSorting}
          className={`w-${columnsWidth[OrdersHistoryTableColumns.Status]}`}
        />
        <ColumnTitle<OrdersHistoryTableColumns>
          title="creation_time"
          columnName={OrdersHistoryTableColumns.CreatedAt}
          currentField={ordersHistoryStore.sorting.column}
          currentDir={ordersHistoryStore.sorting.direction}
          setFilters={ordersHistoryStore.changeSorting}
          className={`w-${columnsWidth[OrdersHistoryTableColumns.CreatedAt]}`}
        />
        <ColumnTitle<OrdersHistoryTableColumns> title="txt_details" className={`w-${columnsWidth[OrdersHistoryTableColumns.Details]}`} />
        <ColumnTitle<OrdersHistoryTableColumns>
          title="total"
          columnName={OrdersHistoryTableColumns.TotalPrice}
          currentField={ordersHistoryStore.sorting.column}
          currentDir={ordersHistoryStore.sorting.direction}
          setFilters={ordersHistoryStore.changeSorting}
          className={`w-${columnsWidth[OrdersHistoryTableColumns.TotalPrice]}`}
        />
      </div>
      <ScrollableBlock showScrollbar scrollClassName="d-flex flex-column full-height pr-4" className="mb-3">
        {ordersHistoryStore.orders.map(([orderId, order]) => (
          <OrdersHistoryRow key={orderId} order={order} />
        ))}
      </ScrollableBlock>
      <Pagination
        visible={ordersHistoryStore.orders.length > 0}
        className="mt-2"
        pagination={ordersHistoryStore.pagination}
        onChange={handleClickPagination}
        showPaginationInfo
      />
    </>
  );
};

export default observer(OrdersHistoryTable);
